export default __webpack_public_path__ + "static/tpx_s_orange-7454fefc06f9f4816a9c2e8bf2a9eda7.png";